// Libraries
import { initializeApp  } from 'firebase/app';
import { getFirestore } from "firebase/firestore";
import { firebaseConfig } from './FirebaseConfig';
import { doc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore"; 

/**
 * Generic way to add or remove items from an array in a Firestore document
 *
 * @param {string} collectionid
 * @param {string} documentid
 * @param {fieldpath} fieldpath - path to the field ```users``` or ```fieldPath(['users', 'value'])```
 * @param {array} values - new value or value to remove
 * @param {string} action - add or remove
 * @param {object} lastmodifiedby - Who made the change, refer to the 'lastmodifiedby' field in the schema
 *
 * ```
 * const collectionid = 'users';
 * const documentid = 'mark.bennett@lendlease.com';
 * const fieldpath = 'projects';
 * const value = 'New Project 1';
 * const action = 'add';
 * const lastmodifiedby = {
 *  'email': getUser.emailaddress,
 *  'givenname': getUser.givenname,
 *  'surname': getUser.surname,
 * };
 *
 * AddRemoveDocumentArray(collectionid, documentid, fieldpath, value, action, lastmodifiedby).then(() => {
 *
 *   console.log('Updated projects array');
 *
 * });
 *
 * ```
 *
 * Documentation
 * - https://firebase.google.com/docs/firestore/manage-data/add-data#update_elements_in_an_array
 * - https://github.com/firebase/snippets-node/blob/e29c2c3ced6c1a3cb14ad5ab7588dac578c06453/firestore/main/index.js#L238-L256
 */


export default async function AddRemoveDocumentArray(collectionid, documentid, fieldpath, value, action, lastmodifiedby){

  //------------------------------------------------------
  //  Update one document with an object 
  //------------------------------------------------------

    //Update existing document
    try {

        if (action !== 'add' && action !== 'remove') throw new Error(`Invalid 'action' provided, 'AddRemoveDocumentArray' only supports 'add' or 'remove'!`);
        if (lastmodifiedby?.email === undefined) throw new Error(`Invalid 'lastmodifiedby' provided, 'AddRemoveDocumentArray' requires a 'email' within the 'lastmodifiedby' object`);
        if (lastmodifiedby?.givenname === undefined) throw new Error(`Invalid 'lastmodifiedby' provided, 'AddRemoveDocumentArray' requires a 'givenname' within the 'lastmodifiedby' object`);
        if (lastmodifiedby?.surname === undefined) throw new Error(`Invalid 'lastmodifiedby' provided, 'AddRemoveDocumentArray' requires a 'surname' within the 'lastmodifiedby' object`);

        //Firestore Database reference
        const app = initializeApp(firebaseConfig);
        const db = getFirestore(app);

        // Document Reference
        const docRef = doc(db, collectionid, documentid);

        // Define Array of Promises
        const docPromises = [];

        // Add value to array
        if (action === 'add') {

            docPromises.push(

                updateDoc(docRef, {
                    [fieldpath] : arrayUnion(value),
                    'lastmodifieddate': new Date(),
                    'lastmodifiedby': lastmodifiedby,
                }),
    
            );

        }

        // Remove value from array
        if (action === 'remove') {
        
            docPromises.push(

                updateDoc(docRef, {
                    [fieldpath] : arrayRemove(value),
                    'lastmodifieddate': new Date(),
                    'lastmodifiedby': lastmodifiedby,
                }),
    
            );

        }

        //Write to document
        return Promise.all(docPromises)

    } catch (error) {
  
        throw new Error(`Function AddRemoveDocumentArray failed to complete, error ${error}`);

    }

  //------------------------------------------------------
}